module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-minus-sign"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b1afbaa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MinusIcon.vue
// module id = 437
// module chunks = 1